























































































import { Component, Vue } from 'vue-property-decorator';
import { ApplicantList } from '@/@types/LibraryComponent';
import AccountDetailModal from '@/components/member/memberCommon/accountDetailModal/AccountDetailModalBase.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountDetailModal,
    AccountIcon,
  },
})
export default class ApplicantListCard extends Vue {
  private applicantList: Array<ApplicantList> = [
    {
      accountName: 'M.M',
      accountIconUrl: 'url',
      desiredPayment: 2000,
      scheduleUptime: 40,
      sideBusinessFlag: 'リモート',
      scheduledJoinStartTime: '2020/11/01',
    },
    {
      accountName: 'セオリー太郎',
      accountIconUrl: 'url',
      desiredPayment: 2000,
      scheduleUptime: 25,
      sideBusinessFlag: 'オンサイト',
      scheduledJoinStartTime: '2020/11/01',
    },
    {
      accountName: 'K.P',
      accountIconUrl: 'url',
      desiredPayment: 3500,
      scheduleUptime: 30,
      sideBusinessFlag: 'リモート',
      scheduledJoinStartTime: '2020/11/01',
    },
    {
      accountName: 'T.Y',
      accountIconUrl: 'url',
      desiredPayment: 3000,
      scheduleUptime: 35,
      sideBusinessFlag: 'リモート',
      scheduledJoinStartTime: '2020/11/01',
    },
    {
      accountName: 'A.W',
      accountIconUrl: 'url',
      desiredPayment: 1000,
      scheduleUptime: 40,
      sideBusinessFlag: 'オンサイト',
      scheduledJoinStartTime: '2020/11/01',
    },
  ];
  /** 週間の稼働時間 */
  private weeklyFullOperationTime: number = 40;
  private isOpenAccountDetailDrawer: boolean = false;
  private openAccountDetailDrawer(): void {
    this.isOpenAccountDetailDrawer = true;
  }
  private closeAccountDetailDrawer(): void {
    this.isOpenAccountDetailDrawer = false;
  }
}
